if (!customElements.get('recently-products')) {
  class RecentlyProducts extends HTMLElement {
    constructor() {
      super()

      this.productsContainer = this.querySelector('[data-products-container]');
      this.currentProductHandle = this.dataset.currentProductHandle;
    }

    connectedCallback() {
      this.init();
    }

    async init() {
      const products = getRecentlyViewedProducts();
      const currentProductIndex = products.indexOf(this.currentProductHandle);

      if (currentProductIndex > -1) {
        products.splice(currentProductIndex, 1);
      }

      if (products.length < 1) return;

      products.length = 4;

      for (const product of products) {
        await this.appendProduct(product);
      }

      this.classList.remove('hidden');
    }

    async appendProduct(productHandle) {
      await fetch(`/products/${productHandle}?view=item-template`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const productMarkup = html.querySelector('[data-product-template]');

          if (productMarkup) {
            this.productsContainer.append(productMarkup);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-products', RecentlyProducts)
}
